<template>
	<Row :gutter="[16, 8]">
		<Col :span="24" :xl="{ span: 12 }">
			<VerticalLayout>
				<TypographyTitle :level="3" class="pd-vertical">{{ $t('rovers.roverStatuses.header') }}</TypographyTitle>
				<TypographyParagraph type="secondary">{{ $t('rovers.roverStatuses.footer') }}</TypographyParagraph>
				<div class="scrollable-x">
					<Table :columns="roverStatusesColumns" :data-source="roverStatuses" :loading="isLoading" size="small">
						<template #headerCell="{ column }">
							<template v-if="['failed', 'pending'].includes(column.dataIndex)">
								<Tooltip :trigger="['hover']" placement="top" :title="$t('rovers.roverStatuses.tableColumns.' + column.dataIndex + 'Tooltip')">
									{{ column.title }} <QuestionCircleOutlined />
								</Tooltip>
							</template>
						</template>
					</Table>
				</div>
			</VerticalLayout>
		</Col>
		<Col :span="24" :xl="{ span: 12 }">
			<VerticalLayout>
				<TypographyTitle :level="3" class="pd-vertical">{{ $t('rovers.roverStatuses.roversTooFarHeader') }}</TypographyTitle>
				<TypographyParagraph type="secondary">
					{{ $t('rovers.roverStatuses.roversTooFarFooter') }}
					<span v-if="roversTooFar.length > 0">
						(<DateTimeDisplay :date="roversTooFarLastDatetime" />)
					</span>
				</TypographyParagraph>
				<div class="scrollable-x">
					<Table :columns="roversTooFarColumns" :data-source="roversTooFar" :loading="isLoading" size="small" />
				</div>
			</VerticalLayout>
		</Col>
	</Row>
</template>


<script>
import { ref, onMounted } from 'vue';
import { Row, Col, Table, TypographyTitle, TypographyParagraph, Tooltip } from 'ant-design-vue';
import { QuestionCircleOutlined } from '@ant-design/icons-vue';

import Api from '@/api/Api';
import Consts from '@/api/Consts';

import VerticalLayout from '@/components/common/VerticalLayout';
import DateTimeDisplay from '@/components/common/DateTimeDisplay';

export default {
	components: {
		Row, Col, Table, TypographyTitle, TypographyParagraph, Tooltip,
		VerticalLayout, DateTimeDisplay,
		QuestionCircleOutlined,
	},
	setup() {
		const roverStatuses = ref([]);
		const roversTooFar = ref([]);
		const roversTooFarLastDatetime = ref(null);
		const isLoading = ref(true);
		onMounted(() => {
			Api.casterStatsRoversTooFarGet(response => {
				roverStatuses.value = response['rover_statuses'];
				roversTooFar.value = response['rovers_too_far']['data'];
				roversTooFarLastDatetime.value = response['rovers_too_far']['last_datetime'];
				isLoading.value = false;
			})
		})
		return {
			roverStatusesColumns: Consts.roverStatusesColumnsComp,
			roverStatuses,
			roversTooFarColumns: Consts.roversTooFarColumnsComp,
			roversTooFar,
			roversTooFarLastDatetime,
			isLoading,
		};
	},
}
</script>
